// lib/nav-links.ts
// Single source of truth for the primary site navigation links shown in
// the header's desktop link row.
//
// Before this file existed, the same five links were hand-copied into
// three separate places: the shared app/(public)/layout.tsx header, the
// homepage's own separate inline header (app/page.tsx keeps one for
// "maximum CRO control" — see that file's header comment), and the
// shared MobileMenu drawer (components/public/MobileMenu.tsx). Nothing
// forced those three copies to agree, and they drifted more than once:
// #957 (Guides missing from the homepage's inline copy) was fixed by
// #962, then #975/#976 showed the same class of gap resurfacing across
// five pages with no corresponding source change — a strong signal that
// hand-copied nav arrays are inherently drift-prone rather than that any
// single copy was wrong at any single point in time.
//
// Every place that renders this link row should map over
// PRIMARY_NAV_LINKS instead of writing out <Link> elements by hand, so
// there is exactly one array to ever edit. See lib/nav-links.test.ts and
// the analogous precedent/fix in lib/auth-allowlist.ts +
// lib/auth-allowlist.test.ts for the same failure mode.

export interface NavLink {
  href: string;
  label: string;
}

export const PRIMARY_NAV_LINKS: NavLink[] = [
  { href: "/", label: "Home" },
  { href: "/reviews", label: "Reviews" },
  { href: "/categories", label: "Categories" },
  { href: "/guides", label: "Guides" },
  { href: "/tools", label: "Tools" },
  { href: "/verdicts", label: "Verdicts" },
  { href: "/about", label: "About" },
];
